// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"912":"0e4488c83a35e92e","2888":"18061f743210bd3b"}[chunkId] + ".css";
};